import React from "react";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const StepsLabel = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }}
  >
    <span
      style={{
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "#86C7A8",
        flexShrink: 0,
        display: "inline-block",
      }}
    />
    <span
      style={{
        ...geistMono,
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "1",
        letterSpacing: "0.1em",
        color: "#86C7A8",
        textTransform: "uppercase",
      }}
    >
      How it works
    </span>
  </div>
);

const STEPS = [
  {
    num: "01",
    title: "Choose Loan",
    desc: "Select the loan option that best fits your personal or business needs.",
  },
  {
    num: "02",
    title: "Submit your Details",
    desc: "Fill in your information and upload the required documents securely.",
  },
  {
    num: "03",
    title: "Review and Approval",
    desc: "Our team reviews your application and contacts you with the next update.",
  },
  {
    num: "04",
    title: "Receive Funds",
    desc: "Once approved, funds are disbursed to your account.",
  },
];

const DesktopStepTrack = () => (
  <div style={{ display: "flex", width: "100%", alignItems: "flex-start" }}>
    {STEPS.map((step, i) => (
      <div
        key={step.num}
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "clamp(20px, 2.78vw, 40px)",
          textAlign: "center",
          position: "relative",
        }}
      >
        {/* Badge */}
        <div
          style={{
            width: "44px",
            height: "44px",
            borderRadius: "8px",
            background: "rgba(255,255,255,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            position: "relative",
            zIndex: 1,
          }}
        >
          <span
            style={{
              ...raleway,
              fontWeight: 700,
              fontSize: "14px",
              color: "rgba(255,255,255,0.5)",
              letterSpacing: "0.05em",
            }}
          >
            {step.num}
          </span>
        </div>

        {/* Dashed connector — 16px gap on each side of the badge edges */}
        {i < STEPS.length - 1 && (
          <div
            style={{
              position: "absolute",
              top: "22px",
              left: "calc(50% + 38px)",
              width: "calc(100% - 76px)",
              display: "flex",
              alignItems: "center",
              transform: "translateY(-50%)",
            }}
          >
            <div
              style={{
                flex: 1,
                borderTop: "1.5px dashed rgba(255,255,255,0.25)",
              }}
            />
            <span
              style={{
                color: "#66A681",
                fontSize: "9px",
                lineHeight: 1,
                flexShrink: 0,
              }}
            >
              ◆
            </span>
          </div>
        )}

        {/* Text */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            padding: "0 clamp(8px, 1.39vw, 20px)",
          }}
        >
          <p
            style={{
              ...raleway,
              fontWeight: 700,
              fontSize: "clamp(14px, 1.25vw, 18px)",
              lineHeight: 1.3,
              color: "#FFFFFF",
              margin: 0,
            }}
          >
            {step.title}
          </p>
          <p
            style={{
              ...raleway,
              fontWeight: 400,
              fontSize: "clamp(12px, 0.97vw, 14px)",
              lineHeight: 1.7,
              color: "rgba(255,255,255,0.6)",
              margin: 0,
            }}
          >
            {step.desc}
          </p>
        </div>
      </div>
    ))}
  </div>
);

const MobileSteps = () => (
  <div style={{ display: "flex", flexDirection: "column" }}>
    {STEPS.map((step, i) => (
      <div key={step.num}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
          <div
            style={{
              width: "44px",
              height: "44px",
              borderRadius: "8px",
              backgroundColor: "rgba(255,255,255,0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <span
              style={{
                ...raleway,
                fontWeight: 700,
                fontSize: "14px",
                color: "#FFFFFF",
                letterSpacing: "0.05em",
              }}
            >
              {step.num}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              paddingTop: "4px",
            }}
          >
            <p
              style={{
                ...raleway,
                fontWeight: 700,
                fontSize: "15px",
                color: "#FFFFFF",
                margin: 0,
                lineHeight: 1.3,
              }}
            >
              {step.title}
            </p>
            <p
              style={{
                ...raleway,
                fontWeight: 400,
                fontSize: "14px",
                color: "rgba(255,255,255,0.6)",
                margin: 0,
                lineHeight: 1.6,
              }}
            >
              {step.desc}
            </p>
          </div>
        </div>
        {i < STEPS.length - 1 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "44px",
              gap: "2px",
              padding: "6px 0",
            }}
          >
            <div
              style={{
                width: 0,
                borderLeft: "2px dashed rgba(255,255,255,0.2)",
                height: "48px",
              }}
            />
            <span style={{ color: "#66A681", fontSize: "12px", lineHeight: 1 }}>
              ◆
            </span>
          </div>
        )}
      </div>
    ))}
  </div>
);

const LoanSteps = () => (
  <>
    <style>{`
			@media (max-width: 767px) {
				.lsteps-desktop { display: none !important; }
				.lsteps-mobile  { display: flex !important; }
			}
			.lsteps-mobile { display: none; }
		`}</style>

    <section
      style={{
        width: "100%",
        background: "transparent",
        boxSizing: "border-box",
        padding: "clamp(32px, 4.44vw, 64px) clamp(20px, 5.56vw, 80px)",
      }}
    >
      <div
        style={{
          maxWidth: "1280px",
          width: "100%",
          background: "#132A22",
          borderRadius: "24px",
          boxSizing: "border-box",
        }}
      >
        {/* Desktop */}
        <div
          className="lsteps-desktop"
          style={{
            padding: "clamp(40px, 5.56vw, 80px) clamp(32px, 4.44vw, 64px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "clamp(32px, 3.89vw, 56px)",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "clamp(12px, 1.39vw, 20px)",
            }}
          >
            <StepsLabel />
            <h2
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "clamp(28px, 4.17vw, 60px)",
                lineHeight: 1.1,
                letterSpacing: "-0.01em",
                color: "#FFFFFF",
                textAlign: "center",
                margin: 0,
              }}
            >
              Apply for a loan in these few simple steps
            </h2>
          </div>

          <DesktopStepTrack />
        </div>

        {/* Mobile */}
        <div
          className="lsteps-mobile"
          style={{
            padding: "40px 24px",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <StepsLabel />
            <h2
              style={{
                ...instrumentSerif,
                fontWeight: 400,
                fontSize: "32px",
                lineHeight: 1.1,
                letterSpacing: "-0.01em",
                color: "#FFFFFF",
                textAlign: "center",
                margin: 0,
              }}
            >
              Apply for a loan in these few simple steps
            </h2>
          </div>
          <MobileSteps />
        </div>
      </div>
    </section>
  </>
);

export default LoanSteps;
